import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductListComponent } from './product-list/product-list.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { BookingComponent } from './BOOKING-PAGE/booking/booking.component';
import { BookTestDriveComponent } from './book-test-drive/book-test-drive.component';
import { CustomerRatingComponent } from './customer-rating/customer-rating.component';
import { OrderConfirmationComponent } from './BOOKING-PAGE/order-confirmation/order-confirmation.component';
import { AuthGuard } from '../shared/services/auth/auth.guard';
import { ProductLeadComponent } from '../product-lead/product-lead.component';
import { BookingAmcListComponent } from './booking-amc-list/booking-amc-list.component';
import { FinanceProductLeadComponent } from './finance-product-lead/finance-product-lead.component';
import { AboutUsComponent } from '../about-us/about-us.component';
import { ExtendedVasComponent } from './extended-vas/extended-vas.component';

const routes: Routes = [
  { path: 'product-list/:search/:columnFive/:type/:list', component: ProductListComponent },
  { path: 'product-list/:lob_name/:sub_lob/:ppl_name', component: ProductListComponent },
  { path: 'product-list', component: ProductListComponent },
  { path: 'product-list/:search', component: ProductListComponent },
  { path: 'product-list/:brand/:lob', component: ProductListComponent },
  { path: 'product-details/:lob_seo/:sub_lob/:ppl_seo/:model/:id', component: ProductDetailComponent },
  { path: 'product-details', component: ProductDetailComponent },
  { path: 'lead-booking', component: BookingComponent,
  canActivate:[AuthGuard],canActivateChild:[AuthGuard] },
  { path: 'lead-booking/:lob_seo/:sub_lob/:ppl_seo/:model/:id', component: BookingComponent,
  canActivate:[AuthGuard],canActivateChild:[AuthGuard] },
  { path: 'lead-booking/:lob_seo/:sub_lob/:ppl_seo/:model/:id/:type', component: BookingComponent,
  canActivate:[AuthGuard],canActivateChild:[AuthGuard] },
  { path: 'lead-booking/:lob_seo/:sub_lob/:ppl_seo/:model/:id/:type/:dealer_code', component: BookingComponent,
  canActivate:[AuthGuard],canActivateChild:[AuthGuard] },
  { path: 'book-test-drive/:lob_seo/:sub_lob/:ppl_seo/:model/:id', component: BookTestDriveComponent,canActivate:[AuthGuard],canActivateChild:[AuthGuard] },
  { path: 'rating-review/:id', component: CustomerRatingComponent },
  { path: 'order-status', component:OrderConfirmationComponent },
  {
    path: 'booking',
    component: BookingComponent,
    canActivate:[AuthGuard],canActivateChild:[AuthGuard]
  },
  {
    path: 'book-test-drive',
    component: BookTestDriveComponent,
    canActivate:[AuthGuard],canActivateChild:[AuthGuard]
  },
  {
    path: 'about-us',
    component: AboutUsComponent
  },
  { path: 'product-lead', component: ProductLeadComponent },
  { path: 'product-lead/:id/:reqid/:orderID', component: ProductLeadComponent },
  { path: 'product-lead/:id/:reqid', component: ProductLeadComponent },
  { path: 'product-lead/:id', component: ProductLeadComponent },
  {path:'booking-amc-list/:lob_seo/:sub_lob/:ppl_seo/:model/:id/:vc/:application/:terrain/:amc_duration/:annual_kms',component:BookingAmcListComponent},
  { path: 'finance-product-lead/:id', component: FinanceProductLeadComponent },
  { path:  'extended-vas/:lob_seo/:sub_lob/:ppl_seo/:model/:id/:selected_price', component: ExtendedVasComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, CarouselModule]
})
export class ProductRoutingModule { }
